export type MultiResumeCoreProductLine = "phase5" | "phase6b";

export function resolveCoreProductLine(
  configuredValue: string | undefined,
  _mode: string | undefined,
): MultiResumeCoreProductLine {
  if (configuredValue === "phase6b") return "phase6b";
  if (configuredValue === "phase5") return "phase5";

  // Missing and invalid selectors always fail closed to the accepted Phase 5 surface.
  return "phase5";
}

export function isCoreV2ProductLine() {
  return resolveCoreProductLine(import.meta.env.VITE_MULTIRESUME_CORE_PRODUCT_LINE, import.meta.env.MODE) === "phase6b";
}
